/* ms-mission.js — Mission section (WS-MISSION). One passive scroll listener (rAF-throttled, idle while off-screen).
   Sets --ms-p (0..1 through the viewport; photos drift with it) and draws the paw-loop line. Skipped for prefers-reduced-motion. */
(function () {
  'use strict';
  var secs = [].slice.call(document.querySelectorAll('[data-ms]'));
  if (!secs.length || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  var vh = window.innerHeight, queued = false, state = [];
  secs.forEach(function (el) { state.push({ el: el, last: -1 }); el.classList.add('ms-live'); el.style.setProperty('--ms-off', '1'); });
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function update() {
    queued = false;
    for (var i = 0; i < state.length; i++) {
      var s = state[i], r = s.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;
      var p = clamp((vh - r.top) / (vh + r.height));
      if (Math.abs(p - s.last) < 0.002) continue;
      s.last = p;
      s.el.style.setProperty('--ms-p', p.toFixed(3));
      /* line starts drawing as the section enters and is complete by the time it is centred */
      s.el.style.setProperty('--ms-off', (1 - clamp((p - 0.14) / 0.4)).toFixed(3));
    }
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', function () { vh = window.innerHeight; queue(); }, { passive: true });
  update();
})();
